import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=10dc55ab"
import script from "./StatusBar.vue?vue&type=script&lang=js"
export * from "./StatusBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports